'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhonelinkOff = function MdPhonelinkOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm38.4 13.4c0.9 0 1.6 0.7 1.6 1.6v16.6c0 1-0.7 1.8-1.6 1.8h-0.4l-5-5h3.6v-11.8h-6.6v8.7l-3.4-3.3v-7c0-0.9 0.8-1.6 1.8-1.6h10z m-31.8-2.9v17.9h17.9z m-3.4-7.8c10.8 10.8 21.6 21.7 32.3 32.5l-2.1 2.1-3.9-3.9h-29.5v-5h3.4v-18.4c0-0.8 0.3-1.6 0.7-2.1l-3-3.1z m33.4 7.3h-21.9l-3.4-3.4h25.3v3.4z' })
        )
    );
};

exports.default = MdPhonelinkOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/phonelink-off.js
// module id = 2646
// module chunks = 0